import cx from 'classnames'

import Styles from './Spinner.module.scss'

interface Props {
  className?: string
  variant?: 'default' | 'blue' | 'dark'
  size?: 'default' | 'large'
}

export const Spinner = ({ className, variant = 'default', size = 'default' }: Props) => {
  return (
    <div className={className} data-testid="spinner">
      <div className={cx(Styles.loadingIcon, Styles[variant], Styles[size])} />
    </div>
  )
}
